import { Switch } from '@chakra-ui/react';
import React from 'react';
import './InputToggle.css';

function InputToggle({ ...rest }) {
  return <Switch size="lg" {...rest} isChecked={rest.value} />;
}

export default InputToggle;
